export const routes = (parentName) => {
  return [
    {
      path: "video",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Video-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Video-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Video-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Video-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
